import React from 'react';
import InvoiceProcessingTab from '../InvoiceProcessingTab';

const InvoiceProcessingTabWrapper: React.FC = () => {
  return (
    <div className="card">
      <InvoiceProcessingTab />
    </div>
  );
};

export default InvoiceProcessingTabWrapper;
